import { render, staticRenderFns } from "./StudentApplicationDetailBase.vue?vue&type=template&id=77653f20&"
import script from "./StudentApplicationDetailBase.vue?vue&type=script&lang=ts&"
export * from "./StudentApplicationDetailBase.vue?vue&type=script&lang=ts&"
import style0 from "./StudentApplicationDetailBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports